import {TaxiMessage} from "./taxi-message";

export class SearchResumed implements TaxiMessage {
  constructor(public draftId: number) {}

  getDraftId(): number {
    return this.draftId;
  }

}
